(function(){
	const toggleBtn = document.querySelector('.whiskyves-search-toggle');
	const overlay = document.getElementById('whiskyves-search-overlay');
	if(!overlay || !toggleBtn) return;

	const closeButtons = overlay.querySelectorAll('[data-close-overlay]');
	const input = overlay.querySelector('.search-field');

	function openOverlay(){
		overlay.classList.add('is-open');
		overlay.setAttribute('aria-hidden', 'false');
		toggleBtn.classList.add('is-hidden');
		setTimeout(()=>{ if(input) input.focus(); }, 50);
		document.addEventListener('keydown', onKeyDown);
	}

	function closeOverlay(){
		overlay.classList.remove('is-open');
		overlay.setAttribute('aria-hidden', 'true');
		toggleBtn.classList.remove('is-hidden');
		document.removeEventListener('keydown', onKeyDown);
	}

	function onKeyDown(e){
		if(e.key === 'Escape'){
			closeOverlay();
		}
	}

	toggleBtn.addEventListener('click', openOverlay);
	closeButtons.forEach(btn => btn.addEventListener('click', closeOverlay));
})(); 